_collow.components.Header = class Header extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.showLogin();
    this.listen(elements.showNavButton, `click`, this.showHideNav);
    this.hideAdminMenu();

    //collapse header incase resize over threshold
    window.addEventListener("resize", this.collapseHeader);

    this.listen(elements.logout, "click", this.logOut);

    // Listen to current user changes from LoginChecker
    this.listen(window, "_collow.current-user", this.handleUserChange);
    // Listen to logout events from LoginChecker
    this.listen(document.body, "_collow.not-logged-in", this.hideLogin);
  }

   /** Handle user state changes from LoginChecker */
  handleUserChange = (event) => {
    const { currentUser } = event.detail;
    if (currentUser) {
      this.showLogin();
    } else {
      this.hideLogin();
    }
  };
  
  /** check if user is logged in and show the email adress of the person */
  showLogin = () => {
    const progressJson = localStorage.getProgressJson();

    if (!progressJson) return;
    this.elements.buttonProfile.removeAttribute("hidden");
    this.elements.buttonRegister.setAttribute("hidden", "");

    const fullname = () => {
      const firstname = progressJson.firstname || '';
      const prefix = progressJson.prefix || '';
      const lastname = progressJson.lastname || '';

      if(firstname === '' && lastname === '') {
        return progressJson.email;
      }
      return `${firstname} ${prefix} ${lastname}`.trim();
    };

    this.elements.person.textContent = fullname();
  };

  /** Hide login UI when user is logged out */
  hideLogin = () => {
    this.elements.buttonProfile.setAttribute("hidden", "");
    this.elements.buttonRegister.removeAttribute("hidden");
  };

  logOut = () => {
    this.dispatch(this.root, "_collow.logout");
    this.elements.buttonProfile.setAttribute("hidden", "");
    this.elements.buttonRegister.removeAttribute("hidden");
    window.location.href = "/login";
  };

  showHideNav = () => {
    const currentStatus =
      this.root.getAttribute("collapsed-header") == "true" ? false : true;
    this.root.setAttribute("collapsed-header", currentStatus);
  };

  /** handler for on mobile size  */
  collapseHeader = (e) => {
    const windowWidth = e.target.innerWidth;
    const currentStatus = this.root.getAttribute("collapsed-header");

    if (windowWidth > 800 && currentStatus == `false`) {
      this.root.setAttribute("collapsed-header", true);
    }
  };

  //hiding the admin menu for those who are not admins.
  hideAdminMenu = () => {
    let progressJson = JSON.parse(window.localStorage.getItem("progressJson"));
    if (progressJson?.role == 2) {
      const anchorTags = this.root.querySelectorAll("a");
      anchorTags.forEach((tag) => {
        if (tag.innerText.includes("Admin")) {
          tag.parentNode.removeAttribute("hidden");
        }
      });
    }
  };
};
